import { mapState } from "vuex";
import { base_url, server_addr } from "../http.js";
import { formatDate, formatDateTime, formatNumber } from "./base_func";

export let BaseCardListData = function() {
  return {
    data() {
      return {};
    },
    computed: {
      fetchParams() {
        return {
          // format: 'json',
        };
      },
      // display_edit_button() {
      //   let itemtype = this.item_type.replace('_', '');
      //   return (
      //     this.permissions.indexOf(`${this.item_type}.${itemtype}_update_all`) !== -1 ||
      //     this.permissions.indexOf(`${this.item_type}.${itemtype}_update_owner`) !== -1
      //   );
      // },
      // display_delete_button() {
      //   let itemtype = this.item_type.replace('_', '');
      //   return (
      //     this.permissions.indexOf(`${this.item_type}.${itemtype}_delete_all`) !== -1 ||
      //     this.permissions.indexOf(`${this.item_type}.${itemtype}_delete_owner`) !== -1
      //   );
      // },
      display_create_button() {
        let itemtype = this.item_type.replace("_", "");
        return (
          this.permissions.indexOf(`${this.item_type}.${itemtype}_create`) !==
          -1
        );
      },

      current_user_id() {
        return this.$store.state.user_id;
      },
      ...mapState([
        "user_id",
        "user_full_name",
        "current_view",
        "current_view_parent",
        "currency",
        "permissions",
        "role",
        "role_display",
        "use_fiscal",
        "company_name",
        "cashes"
      ])
    },
    methods: {
      display_edit_button_by_item(item) {
        let itemtype = this.item_type.replace("_", "");
        if ("can_update" in item) {
          return (
            item.can_update &&
            (this.permissions.indexOf(
              `${this.item_type}.${itemtype}_update_all`
            ) !== -1 ||
              this.permissions.indexOf(
                `${this.item_type}.${itemtype}_update_owner`
              ) !== -1)
          );
        }
        return (
          this.permissions.indexOf(
            `${this.item_type}.${itemtype}_update_all`
          ) !== -1 ||
          this.permissions.indexOf(
            `${this.item_type}.${itemtype}_update_owner`
          ) !== -1
        );
      },
      display_delete_button_by_item(item) {
        let itemtype = this.item_type.replace("_", "");
        if ("can_delete" in item) {
          return (
            item.can_delete &&
            (this.permissions.indexOf(
              `${this.item_type}.${itemtype}_delete_all`
            ) !== -1 ||
              this.permissions.indexOf(
                `${this.item_type}.${itemtype}_delete_owner`
              ) !== -1)
          );
        }
        return (
          this.permissions.indexOf(
            `${this.item_type}.${itemtype}_delete_all`
          ) !== -1 ||
          this.permissions.indexOf(
            `${this.item_type}.${itemtype}_delete_owner`
          ) !== -1
        );
      },

      // Выставляем начальные параметры маршрута
      initialRoute(route) {
        if (route.name === this.item_type + "_detail") {
          const id = route.params.id;
          this.detailView(id);
        } else if (route.name === this.item_type + "_edit") {
          const id = route.params.id;
          this.editView(id);
        } else if (route.name === this.item_type + "_create") {
          this.createView();
        }
      },

      // List actions
      fetchItems() {
        this.loading = true;
        this.$http
          .get(this.baseViewUrl, {
            params: this.fetchParams
          })
          .then(result => {

            // if cash
            if(this.baseViewUrl ===  base_url + "/cashes/") {
              let results = result.data.results;
              results.forEach(item => {
                item.show_close_btn = false;
                item.flip = false;
                item.nonfiscal_tooltip = 'Показать товарную кассу';
              });
              this.data = results;
              this.current_shift();
            }

            else {
              this.data = result.data.results;
            }

            // this.$Spin.hide();
          })
          .finally(() => {
            this.loading = false;
          });
      },

      // Actions with showing drawer
      detailView(id) {
        this.item.id = id;
        this.item.action = "detail";
        this.item.show = true;
      },
      editView(id) {
        this.item.id = id;
        this.item.action = "edit";
        this.item.show = true;
      },
      createView() {
        this.item.id = null;
        this.item.action = "create";
        this.item.show = true;
      },

      // Another actions
      deleteItem(id) {

          const url = this.baseViewUrl + id + "/";
          this.loading = true;
          this.$http
            .delete(url)
            .then(response => {
              this.fetchItems();
              this.removeModal = false;
            })
            .finally(() => {
              this.loading = false;

            });

      },

      // Форматирование
      formatNumber(number) {
        return formatNumber(number);
      },
      formatDate(date) {
        return formatDate(date);
      },
      formatDateTime(datetime) {
        return formatDateTime(datetime);
      },



    },
    mounted() {
      this.fetchItems();
      this.initialRoute(this.$route);
    },
    watch: {
      $route(to, from) {
        this.initialRoute(to);
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/base/base_card_list.js